<template>
	<div>
		<div class="flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
			<WSubTitle text="Coefficients" />
			<span v-if="coefficients?.pending_count" class="text-sm text-orange-500">
				{{ coefficients.pending_count }} pending proposal(s)
			</span>
		</div>
		<div v-if="!coefficients" class="text-sm text-color-secondary">No coefficient data.</div>
		<template v-else>
			<div class="coeff-grid mb-3">
				<div class="coeff-card">
					<div class="kpi-label">Ai</div>
					<div class="kpi-value">{{ fmt(coefficients.Ai) }}</div>
				</div>
				<div class="coeff-card">
					<div class="kpi-label">Bi</div>
					<div class="kpi-value">{{ fmt(coefficients.Bi) }}</div>
				</div>
				<div class="coeff-card">
					<div class="kpi-label">Ci</div>
					<div class="kpi-value">{{ fmt(coefficients.Ci) }}</div>
				</div>
			</div>
			<div v-if="coefficients.pending_proposals?.length">
				<div class="section-label mb-2">Pending proposals</div>
				<ul class="detail-list">
					<li v-for="p in coefficients.pending_proposals" :key="p.id">
						<strong>{{ p.target_period || '—' }}</strong>
						<span class="text-color-secondary">
							· A={{ fmt(p.ai) }} B={{ fmt(p.bi) }} C={{ fmt(p.ci) }}
							· {{ p.data_points ?? '—' }} pts
							· {{ p.generated_by || '—' }}
						</span>
					</li>
				</ul>
				<PButton
					class="mt-1"
					label="Open Coefficients"
					link
					size="small"
					@click="$router.push({ name: 'coefficients' })"
				/>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import { DashboardCoefficients } from '@/brokers/DashboardBroker'

	export default defineComponent({
		name: 'DashCoefficients',
		props: {
			coefficients: {
				type: Object as PropType<DashboardCoefficients | null>,
				default: null,
			},
		},
		methods: {
			fmt(v: number | null | undefined): string {
				if (v == null || Number.isNaN(v)) return '—'
				return Number(v).toLocaleString(undefined, { maximumFractionDigits: 5 })
			},
		},
	})
</script>

<style scoped>
	.coeff-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 0.5rem;
	}
	.coeff-card {
		border: 1px solid var(--surface-border);
		border-radius: 6px;
		padding: 0.5rem 0.75rem;
		background: var(--surface-ground);
	}
	.kpi-label {
		font-size: 0.75rem;
		color: var(--text-color-secondary);
	}
	.kpi-value {
		font-weight: 600;
	}
	.section-label {
		font-size: 0.85rem;
		font-weight: 600;
	}
	.detail-list {
		margin: 0;
		padding-left: 1.1rem;
		font-size: 0.875rem;
	}
</style>
